// src/notifications.js

export function pedirPermissaoNotificacao() {
  return new Promise((resolve) => {
    if (!("Notification" in window)) {
      console.log("Este navegador não suporta notificações.");
      resolve();
      return;
    }
    if (Notification.permission === "granted") {
        resolve();
        return;
    }
    if (Notification.permission !== "denied") {
      Notification.requestPermission().then(permission => {
        if (permission === "granted") {
          console.log("Permissão concedida!");
        }
        resolve();
      });
    } else {
        resolve();
    }
  });
}

export function enviarNotificacao(titulo, options) {
  if (Notification.permission === "granted") {
    new Notification(titulo, options);
  }
}

export function verificarAgendaParaNotificacoes(agendamentos, nomeUtilizador) {
  const agora = new Date();
  const minutosParaAlertar = 15;

  console.log(`Verificando às ${agora.toLocaleTimeString()} para o utilizador: ${nomeUtilizador}`);

  agendamentos.forEach(agendamento => {
    if (agendamento.auditor !== nomeUtilizador) {
      return;
    }
    
    if (agendamento.status === 'Feito' || agendamento.status === 'Não Realizado') {
        return;
    }

    if (!agendamento.horario || !agendamento.data) return;

    const [horas, minutos] = agendamento.horario.split(':');
    const dataAgendamento = new Date(agendamento.data + "T00:00:00");
    dataAgendamento.setHours(horas, minutos);

    const diffEmMs = dataAgendamento.getTime() - agora.getTime();
    const diffEmMinutos = Math.floor(diffEmMs / 60000);

    console.log(`- Tarefa: "${agendamento.descricao || agendamento.auditoria}" às ${dataAgendamento.toLocaleTimeString()}. Faltam ${diffEmMinutos} minutos.`);

    if (diffEmMinutos >= 14 && diffEmMinutos < 15) {
      console.log("!!! ENCONTRADO EVENTO PARA NOTIFICAR !!!");
      const titulo = "Lembrete de Atividade";
      const options = {
        body: `A sua atividade "${agendamento.descricao || agendamento.auditoria}" começa em ${minutosParaAlertar} minutos.`,
        icon: '/logo192.png',
      };
      enviarNotificacao(titulo, options);
    }
  });
}